/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Favorites/FavoritesBox',[
    'jquery',
    'global/all',
    './FavoritesManager',
    'modules/Product/Product',
    'modules/Product/ProductImage'
], function ($, Roc, FavoritesManager, Product, ProductImage) {
    'use strict';

    var baseUrl;
    var selectedListId;

    function reloadWidget(listId) {
        var reloadUrl = baseUrl + '/ReloadFavoritesWidget';
        $.ajax({
            type: 'GET',
            url: reloadUrl,
            dataType: 'json',
            data: { 'listId': listId },
            cache: false,
            success: function (data) {
                selectedListId = listId;
                var HTML = data.html;
                $('#favorites-toolbar-content').html('');
                $('#favorites-toolbar-content').html($('#favorites-toolbar-content', HTML).html());
                $('#favoritesToolbarName').html($('#favoritesToolbarName', HTML).html());
                ProductImage.initImagesLoaded();
                $('.roc-favoritesToolbar.roc-dismissed').removeClass('roc-dismissed');
            }
        });
    }

    function bindChangeListEvt() {
        $(document).on('change', 'select#changeFavoritesList', function () {
            var listId = $(this).val();
            if (listId === 'create') {
                FavoritesManager.addListAndMoveItem();
            } else if (listId !== selectedListId) {
                reloadWidget(listId);
            };
        });
    }

    function bindRemoveItemEvt() {
        $(document).on('click', '.roc-favoritesSummary-list .removeItem', function () {
            var productId = $(this).parent('li').attr('data-product-id');
            FavoritesManager.deleteItem(productId, selectedListId);
        });
    }

    function itemAdded(data) {
        if (data.Result === true) {
            reloadWidget(data.listId);
        }
    }

    function itemDeleted(data) {
        if (data.Result === true) {
            reloadWidget(selectedListId);
        }
    }

    function listAdded(data) {
        if (data.Result === true && data.id) {
            reloadWidget(data.id);
        }
    }

    function bindEvents() {
        bindChangeListEvt();
        bindRemoveItemEvt();
        Roc.EventManager.bind(Roc.Events.favorites.ADD_ITEM, itemAdded);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_ITEM, itemDeleted);
        Roc.EventManager.bind(Roc.Events.favorites.ADD_LIST, listAdded);
    }

    function init(options) {
        baseUrl = options.baseUrl;
        selectedListId = options.selectedListId;
        bindEvents();
    }

    var FavoritesBox = {
        init: init
    };

    Roc.Logger.debug('FavoritesBox.js Loaded', FavoritesBox);

    return FavoritesBox;
});
